import React from "react";
import StepCard from "./StepCard";

const steps = [
  {
    id: "1",
    icon: "/ambassador/step1.svg",
    title: "😉 Get Started ",
    subTitle: [
      <p className='text-cstm-grey text-sm md:text-sm'>Reach out to us on <a className="text-cstm-green hover:underline" target="_blank" href="http://wa.me/+2349155558121">WhatsApp</a>. This is to show your commitment and get important information about you</p>
    ],
    line: true,
  },

  {
    id: "2",
    icon: "/ambassador/step2.svg",
    title: "👋 Get Verified ",
    subTitle: [
      <p className='text-cstm-grey text-sm md:text-sm'>Wait for your application to be verified. A representative from the Reeddi team will reach out on the status of your application.</p>
    ],
    line: true,
  },

  {
    id: "3",
    icon: "/ambassador/step3.svg",
    title: "🚀 Become an Ambassador",
    subTitle: [
      <p className='text-cstm-grey text-sm md:text-sm'>Voila! You are now a Reeddi Ambassador.</p>
    ],
    line: false,
  },
];

export default function Steps() {
  return (
    <section
      className="bg-cstm-green md:bg-transparent"
      style={{ backgroundImage: `url(/ambassador/bg-steps.png)` }}
    >
      <div className="w-11/12 mx-auto my-16 max-w-7xl">
        <div className="flex flex-col gap-y-4 py-8">
          <span
            className="text-sm w-fit rounded text-cstm-green font-medium py-2 px-2"
            style={{
              background: `linear-gradient(112.47deg, #F8FCFA -17.2%, rgba(206, 236, 222, 0) 114.3%)`,
            }}
          >
            3 simple steps
          </span>
          <div className="flex flex-col gap-y-16 sm:flex-row md:flex-row justify-between items-start">
            <div className="font-matter flex flex-col gap-y-4 sm:w-[50%] md:w-[40%]">
              <h2 className="font-semibold text-3xl md:text-5xl">
                How to become a Reeddi Ambassador.
              </h2>
            </div>

            <div className="flex flex-col gap-y-8 sm:w-[45%] md:max-w-[40%]">
              {steps.map((step) => {
                return <StepCard key={step.id} step={step} />;
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
